module.exports = __webpack_public_path__ + "static/media/Coin.bfd779b9.svg";